
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const testimonials = [
  {
    quote: "I've saved over 20 hours per week by purchasing workflows from FlowMarket. The quality is consistently excellent.",
    author: "Sarah Johnson",
    role: "Marketing Director",
    avatar: "SJ"
  },
  {
    quote: "As a seller, I've turned my automation skills into a profitable side business. The platform makes it so simple to reach customers.",
    author: "Michael Chen",
    role: "Automation Consultant",
    avatar: "MC"
  },
  {
    quote: "FlowMarket has transformed how our agency delivers value. We can implement complex workflows for clients in a fraction of the time.",
    author: "Alex Rivera",
    role: "Agency Owner",
    avatar: "AR"
  }
];

const TestimonialsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-secondary">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Loved by Automation Experts
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Join thousands of professionals who buy and sell automation workflows on our marketplace.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-card rounded-lg p-8 border border-border shadow-sm">
              <div className="flex-1 mb-6">
                <p className="italic text-foreground">"{testimonial.quote}"</p>
              </div>
              <div className="flex items-center">
                <Avatar className="h-10 w-10 mr-4">
                  <AvatarImage src="" alt={testimonial.author} />
                  <AvatarFallback>{testimonial.avatar}</AvatarFallback>
                </Avatar>
                <div>
                  <p className="font-medium">{testimonial.author}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
